export default __webpack_public_path__ + "static/media/V.c9ea69ad.svg";